import type { ReactNode } from 'react';
import { useTelegramBack } from '../../hooks/useTelegramBack';
import { DevBack } from './DevBack';

export interface PlainLayoutProps {
  title?: string;
  /** Where Telegram's back button leads; none → the button is hidden. */
  back?: string;
  children: ReactNode;
}

/** Screens that are neither a menu tab nor a step: a title and the native back button. */
export function PlainLayout({ title, back, children }: PlainLayoutProps) {
  const onBack = useTelegramBack(back);
  return (
    <div className="safe-top">
      {back !== undefined && <DevBack onBack={onBack} />}
      <main className="px-4 pt-3 max-w-lg mx-auto pb-[calc(48px+env(safe-area-inset-bottom))]">
        {title && <h1 className="text-xl font-extrabold mb-4">{title}</h1>}
        {children}
      </main>
    </div>
  );
}
